<template>
    <v-app>
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Search Form</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit">
                                    <v-row class="px-2 pt-4 pb-0">

                                        <v-col lg="2" md="2" cols="12">    
                                             <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="From Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="from_date.value.value"
                                                :error-messages="from_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>  
                                        </v-col>
                                        
                                        <v-col lg="2" md="2" cols="12">
                                             <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="To Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="to_date.value.value"
                                                :error-messages="to_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-date-input>
                                        </v-col>

                                        <v-col lg="3" md="3" cols="12">                                
                                            <v-autocomplete
                                                label="Department"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="department_id.value.value"
                                                :items="getHrmDepartmentList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="department_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>

                                        </v-col>

                                         <v-col lg="2" md="2" cols="12">                                
                                            <v-btn class="bg-brand w-15" type="submit" ref="searchButton">Search</v-btn>
                                        </v-col>

                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>


        <v-container fluid style="margin-top: -20px;">
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Cs Quotation List</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">
                                      
                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>


                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="goTo('/purchase/add-cs-quotation')"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Create Cs Quotation
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                     :headers="headers"
                                     :items="getSchema"
                                     :loading="loading"
                                     v-model:items-per-page="itemsPerPage"
                                     :search="search"
                                     :hover="true"                    
                                     density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template> 

                                        <template v-slot:item.approval_status_display="{ item }">
                                            <v-chip
                                            v-if="item.approval_current_process && item.approval_current_process.status === 'Pending'"
                                            color="yellow-darken-3"
                                            size="small"
                                            >
                                                Wating for {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Approved'"
                                            color="green"
                                            size="small"
                                            >
                                                Approved By {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else-if="item.approval_current_process && item.approval_current_process.status === 'Cancelled'"
                                            color="red"
                                            size="small"
                                            >
                                                Cancelled By  {{ item.approval_current_process.approval_step_name.name }}
                                            </v-chip>

                                            <v-chip
                                            v-else
                                            color="green"
                                            size="small"
                                            >
                                                {{ item.approval_status }}
                                            </v-chip>
                                        </template>
                                   
                                        <template v-slot:item.status="{ item }">
                                            <v-chip
                                                :color="statusMap[item.status]?.color || 'grey'"
                                                size="small"
                                                class="text-capitalize"
                                            >
                                            {{ statusMap[item.status]?.label || 'Unknown' }}
                                            </v-chip>
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-btn
                                            icon="mdi-pencil"
                                            size="small"
                                            variant="text"
                                            color="orange"
                                            @click="editItem(item)"
                                            v-if="$updateAccess($route.fullPath) && item.status == '1' && canEdit(item)"
                                            />

                                            <v-btn
                                            icon="mdi-file-document"
                                            size="small"
                                            variant="text"
                                            color="blue"
                                            @click="viewcsQuotationInvoice(item)"
                                            v-if="$updateAccess($route.fullPath)"
                                            />

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import { shallowRef } from 'vue'
import formattedDate from '@/plugins/dateFormatter';
import statusMap from '@/utils/statusMap';
import purchaseApprovalStatus from "@/utils/purchaseApprovalStatus";

export default {
        components: {

        },
        data: () => ({
            itemsPerPage:10,
            panel: [0],
            loading:false,
            search: "",
            dialog: false,
            data:{},
            statusMap,
            purchaseApprovalStatus,
            headers: [
                { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
                { title: "CS Code", key: "code",align: "center" ,sortable: false },
                { title: "Req Code", key: "requisition.code",align: "center" ,sortable: false },
                { title: "RFQ Code", key: "rfq.code",align: "center" ,sortable: false },
                 { title: "Supplier", key: "supplier.supplier_name",align: "left" ,sortable: false },
               
                { title: "Amount",align: "end", key: "amount", sortable: true },
                { title: "Approval Status", align: "center", key: "approval_status_display", sortable: true },
                { title: "Status", align: "center", key: "status", sortable: true },
                { title: "Actions", align: "center", key: "actions", sortable: false }
            ],
        }),
        watch: {
        },
        created(){
            if(this.$store.getters.getHrmDepartmentList.length === 0) {this.$store.dispatch('getHrmDepartmentList');}
        },
        computed:{
            getSchema() {
                return this.$store.getters.getCsQuotationList;
            },
            getHrmDepartmentList() {
                return this.$store.getters.getHrmDepartmentList;
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    // from_date: yup.date().required().label('Rfq Date'),
                    // department_id: yup.number().positive().integer().nullable().label('Department Name'),
                    // warehouse_id: yup.number().positive().integer().nullable().label('Warehouse Name'),                  
                }),
            });

            const department_id = useField('department_id');
            const from_date = useField('from_date');
            const to_date = useField('to_date');
            const errorMessages  = ref('');
            const loading  = ref('');
            const store = useStore();
            const submit = handleSubmit((values) => {
                loading.value = true;
                values.from_date = formattedDate(from_date.value.value);
                values.to_date = formattedDate(to_date.value.value);
                store.dispatch("getCsQuotationList", values)
                    .then((response) => {
                        loading.value = false;
                    })
                    .catch((error) => {            
                        toast.error(error.response.data.message);
                    })
            });
            return {
                submit,
                from_date,
                to_date,
                errorMessages,
                department_id,
                loading
            }
        },
        methods: {
            goTo(val) {
                this.$router.push({ path: val }).catch((err) => {});
            },
            editItem(item){
                // this.$store.commit('setEditingRfq', item);
                this.$router.push({
                    name: 'add-cs-quotation',
                    query: { id: item.id }
                });
                // this.data = { ...item };
                // this.dialog = true;
            },
            canEdit(item){
                return (!item.approval_status || item.approval_status.toLowerCase() !== 'approved' || item.status == 0)
            },
            viewcsQuotationInvoice(item) {
                this.$router.push({
                    name: "view-cs-quotation-invoice",
                    query: { id: item.id },
                });
            },
            exportToPDF() {
                let serialNumber = 1;
                const columns = ['#SL', 'Code', 'Department', 'Warehouse','Amount','Approval Status', 'Status'];
                const rows = this.getSchema.map(item => [serialNumber++, item.code, item.requisition.code, item.rfq.code, item.department.name, item.amount, item.approved_ind, item.status == 1 ? 'POST' : 'DRAFT']);
                this.$exportTableToPDF(columns,rows,'CS Quotation Record','cs_quotation_record_' + this.$fileDate(),'landscape')
            },
            exportToExcel() {
                var data = [['#SL', 'CS Code', 'Req Code', 'RFQ Code','Department','Amount', 'Approval Status', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.requisition.code, item.rfq.code, item.department.name, item.amount, item.approved_ind, item.status == 1 ? 'POST' : 'DRAFT']);
                });
                this.$exportTableToExcel(data,'cs_quotation_record_' + this.$fileDate());
            },
            exportToCSV() {
                var data = [['#SL', 'CS Code', 'Req Code', 'RFQ Code','Department','Amount', 'Approval Status', 'Status']];
                var serialNumber = 1;
                this.getSchema.forEach(item => {
                    data.push([serialNumber++, item.code, item.requisition.code, item.rfq.code, item.department.name, item.amount, item.approved_ind, item.status == 1 ? 'POST' : 'DRAFT']);
                });

                this.$exportTableToCSV(data,'cs_quotation_record_' + this.$fileDate());
            },
        },
        mounted() {
            this.from_date.value.value = new Date();
            this.to_date.value.value = new Date();
            this.$nextTick(() => {
                this.$refs.searchButton.$el.click();
            });   
        }  
    }
</script>